<template>
    <section class="section p-t-6 p-b-6">
        <div class="panel row">
            <div class="panel-aside columns small-12 medium-3 large-4 p-r-6">
                <div class="f-s-5 m-b-2 p-b-1">{{ trans('Email Marketing & Other Services') }}</div>
                <p class="c-muted f-s-3 m-b-1">{{ trans('Connect your email marketing or other service. You can only connect one service per membership.') }}</p>
            </div>

            <integrations-membership-settings
                v-if="integration.provider"
                v-bind:active-integration="integration"
                v-bind:active-lists="lists"
                v-bind:active-tags="tags"
                v-bind:active-list-id="listId"
                v-bind:active-membership-tags="membershipTags"
                v-bind:errors="errors"
            ></integrations-membership-settings>

            <div v-else class="panel-content columns small-12 medium-9 large-8">
                <div class="slat slat-empty slat-empty--large">
                    <div class="row-center row m-b-4 row-middle">
                        <div class="div m-r-4">
                            <img v-bind:src="emptyImageUrl" width="300" />
                        </div>
                        <div class="column p-r-8">
                            <h4 class="c-primary card-title f-s-6 f-w-regular m-b-2">{{ trans('No service added yet') }}</h4>
                            <p class="f-s-4 m-b-5 c-medium-tint">{{ trans('Add MailChimp, Active Campaign and other services') }}</p>
                            <a v-on:click="showModal" class="btn btn-primary">{{ trans('Add Service') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <integrations-modal
            v-on:close="closeModal"
            v-bind:integrations="integrations"
            v-bind:active-integration="integration"
            ref="modal-add-service"
        ></integrations-modal>
    </section>
</template>
<script>
import Errors from '../../../errors';
import { EventBus } from '../../../event-bus.js';
import { membershipIntegrationsLink } from '../../../routes';
import IntegrationsMembershipSettings from './IntegrationsMembershipSettings.vue';
import IntegrationsModal from './IntegrationsModal.vue';

export default {
    components: {
        IntegrationsMembershipSettings,
        IntegrationsModal
    },
    props: {
        membership: {
            type: Object
        },
        activeIntegration: {
            type: Object
        },
        integrations: {
            type: Array
        },
        activeLists: {
            type: Array
        },
        integrationHasTags: {
            type: Boolean
        },
        activeTags: {
            type: [Array, Object]
        },
        activeListId: {
            type: String
        },
        activeMembershipTags: {
            type: Array
        },
        isSomethingLoading: {
            type: Boolean
        },
        validationErrors: {
            type: [Array, Object]
        }
    },
    data() {
        return {
            integration:   this.activeIntegration,
            lists:         this.activeLists,
            hasTags:       this.integrationHasTags,
            tags:          this.activeTags,
            listId:        this.activeListId,
            membershipTags:   this.activeMembershipTags,
            isLoading:     this.isSomethingLoading,

            emptyImageUrl: Kourses.baseUrl + '/img/integrations-emailmarketing.png',
            errors: new Errors(this.validationErrors),
        };
    },
    methods: {
        showModal() {
            this.modal.show = true;
        },
        closeModal() {
            this.modal.reset();
            this.modal.show = false;
        },
        connectIntegration(integration) {
            // Select integration and close modal
            this.loading(true);
            this.hasTags = false;
            this.integration   = integration;
            let connectionData = Object.assign({}, integration.connection);
            this.closeModal();

            // Store the choice and load the integration lists
            window.axios
                .post(membershipIntegrationsLink(this.membership), {
                    'provider':    integration.provider,
                    'integration': integration.uid,
                    'connection':  connectionData,
                }).then((response) => {
                    this.hasTags = integration.config.has_tags;

                    if (this.hasTags) {
                        this.tags = response.data.tags;
                    } else {
                        this.tags = null;
                    }

                    // We need to update the integration UID in order to use
                    // it if we want to connect list immediately
                    this.integration.uid = response.data.uid;

                    this.lists = response.data.lists.slice();
                    this.loading(false);
                }).catch(() => {
                    this.$toast.danger(this.trans("Error when connecting the provider!"));

                    if (response.data && response.data.message) {
                        this.$toast.danger(response.data.message);
                    }

                    this.loading(false);
                });
        },
        removeActiveIntegration() {
            this.$dialog.confirm(this.trans('Do you really want to disconnect the integration?'))
                .then(() => {
                    // Clear out integration and disconnect
                    this.loading(true);
                    this.lists = [];
                    this.listId = '';
                    this.integration = {};
                    this.membershipTags = [];
                    this.errors.clear();

                    // Remove integration from query string
                    window.history.replaceState(null, '', window.location.href.split('?')[0]);

                    window.axios
                        .post(membershipIntegrationsLink(this.membership), {'_method': 'delete'})
                        .then(() => {
                            this.$toast.success(this.trans("Disconnected!"));
                            this.loading(false);
                        }).catch(() => {
                            this.$toast.danger(this.trans("Error!"));
                            this.loading(false);
                        });
                });
        },

        /**
         * Toggle the loading animation
         * @param state
         */
        loading(state) {
            this.isLoading = !!state;
        }
    },
    created() {
        // Add some events
        EventBus.$on('removeActiveIntegration', () => {
            this.removeActiveIntegration();
        });
        EventBus.$on('showIntegrationModal', () => {
            this.showModal();
        });
        EventBus.$on('closeIntegrationModal', () => {
            this.closeModal();
        });
        EventBus.$on('connectIntegration', (integration) => {
            this.connectIntegration(integration);
        });
        EventBus.$on('connectOAuthIntegration', (integration) => {
            this.connectIntegration(integration);
        });
    },
    mounted() {
        // Define the modal
        this.modal = this.$refs['modal-add-service'];
    },
}
</script>
